import {iframeAppBiLoggerFactory} from '@wix/iframe-app-bi-logger';
import {Logger} from '@wix/web-bi-logger/dist/src/types';
import * as Wix from 'wix-sdk';

export const biLogger: Logger = iframeAppBiLoggerFactory(Wix, {endpoint: 'music-ugc'}).logger();

export const biErrorLogger = iframeAppBiLoggerFactory(Wix, {endpoint: 'trg'}).logger();
